import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Brief service interruptions should not turn a normal page load into an
// empty screen. Retry safe read requests once; never repeat a write action.
api.interceptors.response.use(undefined, async (error) => {
  const config = error.config;
  const status = error.response?.status;
  if (
    config &&
    !config.__brewmateRetried &&
    (config.method || "get").toLowerCase() === "get" &&
    [502, 503, 504].includes(status)
  ) {
    config.__brewmateRetried = true;
    await new Promise((resolve) => setTimeout(resolve, 700));
    return api.request(config);
  }
  return Promise.reject(error);
});

export default api;
